import { Box, CircularProgress } from "@mui/material";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import branchesService from "services/branches-service";

export default function TasksConsolidatedReportGeneration({ data }) {
  const [html, setHtml] = useState("");

  async function generateHtml() {
    const includeTaskPhotos = Boolean(data.includeTaskPhotos);
    const [response, returnedData] =
      await branchesService.getConsolidatedTasksReportHtml(
        { branchGroupId: data.branchGroup.id },
        {
          includeTaskPhotos,
          filters: {
            ...data.filters,
            date: {
              ...data.filters.date,
              from: data.filters.date?.from?.$d,
              to: data.filters.date?.to?.$d,
            },
          },
        },
      );

    if (response.ok) {
      setHtml(returnedData.html);
    }
  }

  useEffect(() => {
    generateHtml();
  }, []);

  if (!html) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={24} color="info" />
      </Box>
    );
  }
  return (
    <Box sx={{ width: "100%", backgroundColor: "whitesmoke" }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "21cm",
          margin: "0 auto",
          backgroundColor: "white.main",
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(html),
          }}
        />
      </Box>
    </Box>
  );
}
